import React from "react";

export default function ConfirmMessage({ isOpen, onConfirm, onCancel, message = "¿Está seguro?" }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/55 backdrop-blur-sm px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm border border-slate-200 overflow-hidden">
        {/* Icono + título */}
        <div className="flex items-center gap-3.5 px-6 pt-6 pb-4">
          <div className="w-11 h-11 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
              <path d="M11 8v5M11 16h.01" stroke="#D97706" strokeWidth="2" strokeLinecap="round" />
              <path
                d="M9.44 2.74L1.14 17A1.75 1.75 0 002.67 19.5h16.66A1.75 1.75 0 0020.86 17L12.56 2.74a1.75 1.75 0 00-3.12 0z"
                stroke="#D97706"
                strokeWidth="1.7"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div>
            <h3 id="confirm-title" className="text-sm font-bold text-slate-800">
              Confirmar acción
            </h3>
            <p className="text-xs text-slate-500 mt-0.5">Esta operación no puede deshacerse</p>
          </div>
        </div>

        {/* Mensaje */}
        <p className="px-6 pb-6 text-sm text-slate-600 leading-relaxed">{message}</p>

        {/* Acciones */}
        <div className="flex items-center gap-3 px-6 pb-6">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors cursor-pointer"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold text-white bg-blue-700 hover:bg-blue-800 transition-colors shadow-md cursor-pointer"
          >
            Sí, continuar
          </button>
        </div>
      </div>
    </div>
  );
}
